define('LNRS/Components/Social/SocialFacebook',["jquery", "eventManager"], function ($, eventManager) {
    function SocialFacebook(scope) {
        eventManager.subscribe("SiteSharingDataLoaded", function (socailSharingData) {
            var fullUrl = '';
            $.each(socailSharingData, function (index, socialNetworkData) {
                if (socialNetworkData.Name.indexOf('Facebook') != -1) {
                    fullUrl = socialNetworkData.FullUrl;
                }
            });
            if (fullUrl.length > 0) {
                $('#social-share-facebook-link').attr('onclick', fullUrl);
            }
        }.bind(this));
    }

    return function init(args) {
        return new SocialFacebook(args.scope);
    };
});
